var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-app",
    { attrs: { id: "app" } },
    [
      _c("slm-navbar"),
      _vm._v(" "),
      _c(
        "v-main",
        { staticClass: "app--main container-fluid" },
        [
          _vm.authenticated ? _c("slm-sidenav") : _vm._e(),
          _vm._v(" "),
          _vm.authenticated ? _c("slm-right-sidenav") : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "app--card",
              class: { authenticated: _vm.authenticated },
            },
            [
              _c("v-progress-linear", {
                attrs: {
                  active: _vm.isLoading,
                  indeterminate: _vm.isLoading,
                  height: "4",
                  color: "blue",
                },
              }),
              _vm._v(" "),
              _c("router-view", {
                key: _vm.$route.fullPath,
                staticClass: "app--router-view",
                class: { "d-flex overflow-hidden p-0": !_vm.authenticated },
                attrs: { id: "app-identifier" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.snackbars, function (item, index) {
            return _c(
              "v-snackbar",
              {
                key: `snackbar-${index}`,
                style: { "margin-bottom": _vm.calcSnackbarMargin(index) },
                attrs: {
                  timeout: -1,
                  value: true,
                  elevation: "4",
                  color: "white",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "action",
                      fn: function ({ attrs }) {
                        return [
                          _c(
                            "v-btn",
                            _vm._b(
                              {
                                attrs: { color: "light-blue", icon: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeSnackbar(index)
                                  },
                                },
                              },
                              "v-btn",
                              attrs,
                              false
                            ),
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              },
              [
                item.icon
                  ? _c("v-icon", { attrs: { color: item.iconColor } }, [
                      _vm._v(_vm._s(item.icon)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "grey--text text--darken-4",
                    attrs: { id: "snackbar" },
                    domProps: { innerHTML: _vm._s(item.message) },
                  },
                  [_vm._v(_vm._s(item.message))]
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }